import posthog from "posthog-js";

posthog.init(window.posthog_id, {autocapture: false});

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function getJwtToken() {
    return localStorage.getItem('jwt') || getCookie('user');
}

export function sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

export function captureEvent(event_name, properties){
       posthog.capture(event_name, properties);

}

export function identifyUser(email){
       console.log("user identified", email);
       posthog.identify(email);
}

export function getEmail() {
    return localStorage.getItem('email') || null;
}

